import React from 'react';
import { HelperText } from 'components/Forms';
import { ConnectedFormInputProps } from 'types/form-field';

/**
 * This component renders only the error associated with a field. It's useful
 * when there's not enough data to show the actual form field and an alternate
 * empty UI is being displayed but we still want to show the field's error (and
 * allow the <Form /> to focus it.)
 */
export const FieldError = React.forwardRef(function FieldErrorWithRef(
  { error }: ConnectedFormInputProps<HTMLInputElement>,
  ref?: React.ForwardedRef<HTMLSpanElement>,
): JSX.Element | null {
  return (
    <span tabIndex={-1} ref={ref}>
      {error ? <HelperText error>{error}</HelperText> : null}
    </span>
  );
});
